import "./MainSectionTours.css";
import React, { useState, useEffect } from "react";

function Tours() {
  const [flippedCards, setFlippedCards] = useState({});

  const handleFlip = (cardIndex) => {
    setFlippedCards((prev) => ({
      ...prev,
      [cardIndex]: !prev[cardIndex],
    }));
  };

  useEffect(() => {
    const timers = Object.keys(flippedCards).map((cardIndex) => {
      if (flippedCards[cardIndex]) {
        const timeoutDuration = cardIndex <= 3 ? 35000 : 10000;
        return setTimeout(() => {
          setFlippedCards((prev) => ({
            ...prev,
            [cardIndex]: false,
          }));
        }, timeoutDuration);
      }
      return null;
    });

    return () => timers.forEach((timer) => timer && clearTimeout(timer));
  }, [flippedCards]);

  return (
    <>
      <section className="Tours" id="Tours">
        <h2>Private Tours</h2>
        <div className="allcards">

          {/* First Card */}
          <div className={`card first-card ${flippedCards[1] ? "flipped" : ""}`} onClick={() => handleFlip(1)} role="button" tabIndex="0" aria-label="Toggle description for Full-Day Tour Amalfi">
            <div className="card-body">
              <div className="card-front">
                <div className="card-image">
                  <img src="../Assets/amalfitour.svg" alt="Amalfi Tour Illustration" />
                </div>
                <div className="card-title title-firstcard">
                  <h4>Full-Day Tour (7 Hours): <br /> Amalfi, Conca, Atrani, Minori, Maiori</h4>
                  <p className="readmore">Read Description</p>
                </div>
              </div>
              <div className="card-descr first-descr">
                <p>
                  Immerse yourself in the magic of the Amalfi Coast with a full-day adventure. Visit picturesque towns including Praiano, Conca dei Marini, Amalfi, Atrani, Minori, and Maiori. Pause for a delicious lunch at the scenic Tonnarella restaurant, then continue exploring and swimming in beautiful spots on the way back to Positano. On board, you’ll find everything you need for a comfortable journey—drinks, snacks, snorkeling gear, music on demand, a fresh water shower, shaded seating, and plenty of space to relax.
                </p>
                <h5> Contact me for more info.</h5>
                <p className="back">Back</p>
              </div>
            </div>
          </div>

          {/* Second Card */}
          <div className={`card second-card ${flippedCards[2] ? "flipped" : ""}`} onClick={() => handleFlip(2)} role="button" tabIndex="0" aria-label="Toggle description for Full-Day Tour Li Galli">
            <div className="card-body">
              <div className="card-front">
                <div className="card-image">
                  <img src="../Assets/fulltimetour.svg" alt="Li Galli Tour Illustration" />
                </div>
                <div className="card-title title-secondcard">
                  <h4>Full-Day Tour (7 Hours): <br /> Li Galli, Nerano</h4>
                  <p className="readmore">Read Description</p>
                </div>
              </div>
              <div className="card-descr">
                <p>
                  Immerse yourself in the natural beauty of the Amalfi Coast with a full-day adventure. Cruise towards Li Galli Island, explore the hidden gems of Nerano, and visit scenic spots like Scoglio Isca, Scoglio Scruopolo, Fiordo di Crapolla, and Punta Sant’Elia. Enjoy swimming in crystal-clear waters and take in breathtaking views along the way. On board, you’ll find everything you need—drinks, snacks, snorkeling gear, music on demand, a fresh water shower, shaded seating, and plenty of space to relax. This 7-hour tour is perfect for nature lovers seeking a peaceful coastal escape.
                </p>
                <h5> Contact me for more info.</h5>
                <p className="back">Back</p>
              </div>
            </div>
          </div>

          {/* Third Card */}
          <div className={`card third-card ${flippedCards[3] ? "flipped" : ""}`} onClick={() => handleFlip(3)} role="button" tabIndex="0" aria-label="Toggle description for Half-Day Tour">
            <div className="card-body">
              <div className="card-front">
                <div className="card-image last-cardimg">
                  <img src="../Assets/halfdaytour.svg" alt="Half-Day Tour Illustration" />
                </div>
                <div className="card-title">
                  <h4>Half-Day Tour (4 Hours)</h4>
                  <p className="readmore">Read Description</p>
                </div>
              </div>
              <div className="card-descr">
                <p>
                  Discover the beauty of the Amalfi Coast on a relaxing 4-hour cruise. Visit the enchanting Li Galli Island and explore the stunning natural coastline. Enjoy swimming in crystal-clear waters or simply unwind on board with all the comforts you need—refreshing drinks, tasty snacks, snorkeling equipment, and music at your fingertips. There’s also a fresh water shower and shaded areas to keep you cool. This tour is perfect for a short but memorable escape along the coast.
                </p>
                <h5>Contact me for more info.</h5>
                <p className="back">Back</p>
              </div>
            </div>
          </div>

          {/* Fourth Card */}
          <div className={`card fourth-card ${flippedCards[4] ? "flipped" : ""}`} onClick={() => handleFlip(4)} role="button" tabIndex="0" aria-label="Toggle description for Sunset Cruise">
            <div className="card-body">
              <div className="card-front">
                <div className="card-image last-cardimg">
                  <img src="../Assets/sunsettour.svg" alt="Sunset Cruise Illustration" />
                </div>
                <div className="card-title">
                  <h4>Sunset Cruise - Evening</h4>
                  <p className="readmore">Read Description</p>
                </div>
              </div>
              <div className="card-descr lastDescr">
                <p>
                  Experience the magic of the Amalfi Coast with the sun setting over the stunning coastline. This is a truly unforgettable way to experience the beauty of this enchanting region.
                </p>
                <h5> Contact me for more info.</h5>
                <p className="back">Back</p>
              </div>
            </div>
          </div>

          {/* Fifth Card */}
          <div className={`card fifth-card ${flippedCards[5] ? "flipped" : ""}`} onClick={() => handleFlip(5)} role="button" tabIndex="0" aria-label="Toggle description for Romantic Proposal Tour">
            <div className="card-body">
              <div className="card-front">
                <div className="card-image last-cardimg">
                  <img src="../Assets/proposaltour.svg" alt="Romantic Proposal Illustration" />
                </div>
                <div className="card-title">
                  <h4>Romantic Proposal Tour</h4>
                  <p className="readmore">Read Description</p>
                </div>
              </div>
              <div className="card-descr lastDescr">
                <p>
                  Make your proposal unforgettable with our boat tour on the Amalfi Coast! Capture the perfect moment with a stunning backdrop of the coastline.
                </p>
                <h5> Contact me for more info.</h5>
                <p className="back">Back</p>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Tours;